/* Elite Sport Colombia · páginas internas (Nosotros, Tecnología): animaciones portadas de elitesport.soccer */
(function () {
  'use strict';
  function run() {
    if (document.querySelector('.es-pg-about')) {
// Stat box top line reveal
var statObs = new IntersectionObserver(function(entries) {
  entries.forEach(function(e) {
    if (e.isIntersecting) { e.target.classList.add('in'); statObs.unobserve(e.target); }
  });
}, { threshold: .2 });
document.querySelectorAll('.stat-box').forEach(function(el) { statObs.observe(el); });

// Timeline spine fill on scroll
(function() {
  var fill = document.getElementById('tlFill');
  var track = document.querySelector('.tl-track');
  if (!fill || !track) return;
  function updateFill() {
    var rect = track.getBoundingClientRect();
    var total = rect.height;
    var visible = Math.max(0, window.innerHeight - rect.top);
    var pct = Math.min(100, Math.max(0, (visible / total) * 100));
    fill.style.height = pct + '%';
  }
  window.addEventListener('scroll', updateFill, { passive: true });
  var pw = document.querySelector('.page-wrapper'); if (pw) pw.addEventListener('scroll', updateFill, { passive: true });
  updateFill();
})();

// ─── TIMELINE GLOVE SWITCHER ───
(function(){
  var img = document.getElementById('tlGloveImg');
  var frame = document.getElementById('tlGloveFrame');
  var eraEl = document.getElementById('tlGloveEra');
  var yrEl = document.getElementById('tlGloveYr');
  if(!img) return;

  var current = {glove: img.getAttribute('src'), era: eraEl.textContent, year: yrEl.textContent};

  function switchGlove(glove, era, year) {
    if(glove === current.glove) return;
    current = {glove, era, year};

    // Exit animation
    img.classList.add('exit');
    frame.classList.add('glowing');
    yrEl.classList.add('flip');

    setTimeout(function(){
      img.src = glove;
      eraEl.textContent = era;
      yrEl.textContent = year;

      // Enter: start from scaled-up rotated invisible
      img.classList.remove('exit');
      img.classList.add('enter');

      requestAnimationFrame(function(){
        requestAnimationFrame(function(){
          // Trigger transition to normal state
          img.classList.remove('enter');
          yrEl.classList.remove('flip');
        });
      });

      // Remove glow after pulse
      setTimeout(function(){
        frame.classList.remove('glowing');
      }, 700);
    }, 320);
  }

  var nodes = document.querySelectorAll('[data-glove]');
  var obsOpts = {threshold: 0.6};

  var tlObs = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        var glove = e.target.getAttribute('data-glove');
        var era = e.target.getAttribute('data-era');
        var year = e.target.getAttribute('data-year');
        switchGlove(glove, era, year);
      }
    });
  }, obsOpts);

  nodes.forEach(function(n){ tlObs.observe(n); });
})();


    }
    if (document.querySelector('.es-pg-tech')) {
      document.querySelectorAll('.es-pg-tech .rv,.es-pg-tech .rv-img').forEach(function (el) { el.classList.add('es-rv'); });
// ── Hero stats count-up ─────────────────────────────────
(function(){
  var statsEl = document.getElementById('heroStats');
  if(!statsEl) return;
  var nums = statsEl.querySelectorAll('.t-hs-num[data-count]');
  var DUR  = 1800;   // ms for the count-up
  var DELAY= 320;    // ms before first number starts
  var STAGGER = 130; // ms between each number

  function easeOutExpo(t){ return t===1 ? 1 : 1 - Math.pow(2, -10*t); }

  function countUp(el, target, suffix, startDelay){
    setTimeout(function(){
      var start = null;
      function step(ts){
        if(!start) start = ts;
        var prog = Math.min((ts - start) / DUR, 1);
        var eased = easeOutExpo(prog);
        el.textContent = Math.floor(eased * target) + suffix;
        if(prog < 1){
          requestAnimationFrame(step);
        } else {
          el.textContent = target + suffix;
          // brief white flash when number lands
          el.classList.add('flash');
          setTimeout(function(){ el.classList.remove('flash'); }, 180);
        }
      }
      requestAnimationFrame(step);
    }, startDelay);
  }

  // fire when stats section enters viewport
  var fired = false;
  var hsObs = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting && !fired){
        fired = true;
        statsEl.classList.add('fired');
        nums.forEach(function(el, i){
          var target = parseInt(el.dataset.count, 10);
          var suffix = el.dataset.suffix || '';
          countUp(el, target, suffix, DELAY + i * STAGGER);
        });
        hsObs.disconnect();
      }
    });
  }, {threshold: 0.3});
  hsObs.observe(statsEl);
})();

// Scroll reveal
var ro=new IntersectionObserver(function(es){
  es.forEach(function(e){
    if(e.isIntersecting){e.target.classList.add('in');ro.unobserve(e.target)}
  });
},{threshold:.12});
document.querySelectorAll('.rv,.rv-img').forEach(function(el){ro.observe(el)});

// Animate palm circles — tachometer style (accelerate past target, then settle back)
var CIRC=138.2;
function animateTacho(fill,numEl,pct){
  var overshoot=Math.min(pct+14,100);
  var p1Dur=700,p2Dur=520;
  var s1=null,s2=null;
  function phase1(ts){
    if(!s1)s1=ts;
    var prog=Math.min((ts-s1)/p1Dur,1);
    var ease=prog*prog*(3-2*prog); // smooth accel
    var cur=ease*overshoot;
    fill.style.strokeDashoffset=CIRC*(1-cur/100);
    if(numEl)numEl.textContent=Math.floor(cur);
    if(prog<1){requestAnimationFrame(phase1);}
    else{requestAnimationFrame(phase2);}
  }
  function phase2(ts){
    if(!s2)s2=ts;
    var prog=Math.min((ts-s2)/p2Dur,1);
    var ease=1-Math.pow(1-prog,4); // fast decel / settle
    var cur=overshoot-(overshoot-pct)*ease;
    fill.style.strokeDashoffset=CIRC*(1-cur/100);
    if(numEl)numEl.textContent=Math.floor(cur);
    if(prog<1){requestAnimationFrame(phase2);}
    else{fill.style.strokeDashoffset=CIRC*(1-pct/100);if(numEl)numEl.textContent=pct;}
  }
  requestAnimationFrame(phase1);
}
var circObs=new IntersectionObserver(function(es){
  es.forEach(function(e){
    if(!e.isIntersecting)return;
    var card=e.target;
    card.querySelectorAll('.pcircle-fill').forEach(function(fill){
      var pct=parseInt(fill.dataset.pct)||0;
      var numEl=fill.closest('svg').querySelector('.pcircle-num');
      animateTacho(fill,numEl,pct);
    });
    circObs.unobserve(card);
  });
},{threshold:.35});
document.querySelectorAll('.pcard').forEach(function(c){circObs.observe(c)});

// ── PALM ANATOMY · SVG Annotation Lines ─────────────────
(function(){
  var stageEl = document.getElementById('paStage');
  var imgEl   = document.getElementById('paLayerImg');
  var svgEl   = document.getElementById('paConnectors');
  var annIds  = ['paAnn1','paAnn2','paAnn3','paAnn4'];

  if(!stageEl || !imgEl || !svgEl) return;

  // Vertical position of each layer's center as a fraction of the RENDERED image height.
  // Calibrated visually from the exploded-layers photo.
  var layerFracs = [0.17, 0.37, 0.57, 0.77];

  var drawn = false;

  function draw(){
    if(drawn) return;
    drawn = true;

    // Wait one frame so layout is stable
    requestAnimationFrame(function(){
      var stageRect = stageEl.getBoundingClientRect();
      var imgRect   = imgEl.getBoundingClientRect();

      // Compute rendered image bounds inside its container (object-fit: contain)
      var natW = imgEl.naturalWidth  || 900;
      var natH = imgEl.naturalHeight || 1200;
      // padding applied in CSS (2.5rem top/bottom, 2rem left/right ≈ 40/32px)
      var padV = parseFloat(getComputedStyle(imgEl).paddingTop)  || 40;
      var padH = parseFloat(getComputedStyle(imgEl).paddingLeft) || 32;
      var boxW = imgRect.width  - padH * 2;
      var boxH = imgRect.height - padV * 2;
      var scale   = Math.min(boxW / natW, boxH / natH);
      var rendW   = natW * scale;
      var rendH   = natH * scale;
      var imgLeft = imgRect.left - stageRect.left + padH + (boxW - rendW) / 2;
      var imgTop  = imgRect.top  - stageRect.top  + padV + (boxH - rendH) / 2;

      // Right edge of rendered image (where lines will start)
      var imgRightX = imgLeft + rendW;

      // Update SVG viewport
      svgEl.setAttribute('viewBox', '0 0 ' + stageRect.width + ' ' + stageRect.height);

      annIds.forEach(function(id, i){
        var ann = document.getElementById(id);
        if(!ann) return;

        var annRect = ann.getBoundingClientRect();

        // Image-side anchor: right edge of image at this layer's height
        var ancX = imgRightX - 8;
        var ancY = imgTop + rendH * layerFracs[i];

        // Label-side anchor: left edge of annotation container (before text padding)
        var lblX = annRect.left - stageRect.left + 6;  // land 6px into the container, before text
        var lblY = annRect.top  - stageRect.top + 22;  // near the title

        // Horizontal bend point
        var bendX = lblX - 28;

        // Draw L-shaped path: anchor → bend at anchor height → up/down to label
        var d = 'M ' + ancX  + ' ' + ancY  +
                ' L ' + bendX + ' ' + ancY  +
                ' L ' + lblX  + ' ' + lblY;

        var path = document.createElementNS('http://www.w3.org/2000/svg','path');
        path.setAttribute('d', d);
        path.setAttribute('fill', 'none');
        path.setAttribute('stroke', 'rgba(197,162,120,.45)');
        path.setAttribute('stroke-width', '1');
        path.setAttribute('stroke-linecap', 'round');
        path.setAttribute('stroke-linejoin', 'round');

        var len = 300;
        try { len = path.getTotalLength(); } catch(e){}
        path.style.strokeDasharray = len;
        path.style.strokeDashoffset = len;
        svgEl.appendChild(path);

        // Dot on the image
        var dot = document.createElementNS('http://www.w3.org/2000/svg','circle');
        dot.setAttribute('cx', ancX); dot.setAttribute('cy', ancY); dot.setAttribute('r','3.5');
        dot.setAttribute('fill','rgba(197,162,120,.65)');
        dot.style.opacity = '0';
        svgEl.appendChild(dot);

        // Dot on the label
        var dot2 = document.createElementNS('http://www.w3.org/2000/svg','circle');
        dot2.setAttribute('cx', lblX); dot2.setAttribute('cy', lblY); dot2.setAttribute('r','2.5');
        dot2.setAttribute('fill','rgba(197,162,120,.4)');
        dot2.style.opacity = '0';
        svgEl.appendChild(dot2);

        var delay = i * 280;

        // Stagger: animate line, then dots, then show annotation card
        setTimeout(function(){
          path.style.transition = 'stroke-dashoffset 0.85s cubic-bezier(.16,1,.3,1)';
          path.style.strokeDashoffset = '0';
          setTimeout(function(){
            dot.style.transition = dot2.style.transition = 'opacity .35s ease';
            dot.style.opacity = '1'; dot2.style.opacity = '1';
          }, 700);
          ann.classList.add('vis');
        }, delay);
      });
    });
  }

  // Trigger when stage scrolls into view
  var obs = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){ draw(); obs.unobserve(e.target); }
    });
  }, {threshold: 0.3});
  obs.observe(stageEl);

  // Redraw on resize
  window.addEventListener('resize', function(){
    if(!drawn) return;
    svgEl.innerHTML = '';
    drawn = false;
    draw();
  });
})();

// Subnav active section tracking
var sections=['palms','cuts','backhands','protection','sidegrip'];
var snLinks=document.querySelectorAll('.t-subnav-link[data-sec]');
var snObs=new IntersectionObserver(function(es){
  es.forEach(function(e){
    if(e.isIntersecting){
      var id=e.target.id;
      snLinks.forEach(function(l){
        l.classList.toggle('sn-active',l.dataset.sec===id);
      });
    }
  });
},{threshold:.2,rootMargin:'-20% 0px -60% 0px'});
sections.forEach(function(id){
  var el=document.getElementById(id);
  if(el)snObs.observe(el);
});

    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
